<template>
  <div class="simmerring__container">
    <div class="simmerring__container">
      <h1 class="h1--underline">
        {{ $tv('simmerringSelectorTitle', 'simmerringSelector') }}
      </h1>
    </div>
    <div class="simmerring-selector__content">
      <simmerring-selector />
    </div>
    <PopupSimmerringDisclaimer
      :show="showDisclaimer"
      :class="showDisclaimer ? 'popup--visible' : ''"
    />
  </div>
</template>

<script setup lang="ts">
import useBreadcrumb from '~/composables/useBreadcrumb'
import useI18nExtended from '~/composables/usei18nExtended'
import {useConfigurationDataStore} from '@/store/configuration-data'
import {useSimmerringHelper} from '~/composables/simmerring_selector'
import PopupSimmerringDisclaimer from '~/components/popup/PopupSimmerringDisclaimer.vue'
import createSeoMetaInfo from '~/assets/js/opengraph/helper.ts'
import {useQuerySettings} from '~/composables/simmerring_query.ts'

const seoData = createSeoMetaInfo(useSimmerringHelper().getSeoOptions())
useSeoMeta(seoData)

const i18n = useI18nExtended()
useQuerySettings()

useBreadcrumb([
  {
    label: i18n.tv('simmerring', 'breadcrumbs'),
    path: '/simmerring-selector'
  }
])

const router = useRouter()
const route = useRoute()
let i18nHead = useLocaleHead({addSeoAttributes: true, route: route, router: router, i18n: i18n}).value

const head = {
  ...i18nHead,
  title: i18n.tv('pageTitle', 'simmerringSelector')
}

useHead(head)

const showDisclaimer = computed(() => {
  return !useConfigurationDataStore().acceptedSimmerringSelectorDisclaimer
})

</script>
<style lang="scss">
.simmerring__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  h1 {
    margin: 0 2rem;
  }

  .simmerring-selector__content {
    display: flex;
    align-self: stretch;
    justify-content: space-around;
    margin-top: 1rem;
    background-color: $color__content--background__primary;
    padding: 0 2rem;
    overflow: hidden;
  }

  @include breakpoint-down($md) {
    h1 {
      margin-top: 2rem;
    }
  }
}
</style>
